module.exports = __webpack_public_path__ + "static/Frame.ce8b532e.svg";